import React from 'react'

const Personaldash = () => {
  return (
    <div>Personaldash</div>
  )
}

export default Personaldash